import { SET_SEARCH_TRANSACTION_RESPONSE } from "../action";
import { searchTransactionResponse } from "./initial-store";

const initialState = searchTransactionResponse;

function searchTxnResponseReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SEARCH_TRANSACTION_RESPONSE:
      return action.payload;
    default:
      return state;
  }
}

export default searchTxnResponseReducer;
